import React from "react";
import './Publications.css';
import { Button } from '@chakra-ui/react'
import pubThumb1  from '../../assets/img/pub-thumb1.jpg';
import pubThumb2  from '../../assets/img/pub-thumb2.jpg';
import pubThumb3  from '../../assets/img/pub-thumb3.jpg';
import pubThumb4  from '../../assets/img/pub-thumb4.jpg';
import mediumSVG  from '../../assets/icons/medium-logo.svg';
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class Publications extends React.Component {

	renderPublication(publication){
		return <AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={300}>
			<a className="publication-wrapper" href={publication.href} key={publication.header} target="_blank" rel="noreferrer">
				<div className="publication-thumb">
					<img src={publication.thumb} alt=""/>
				</div>
				<div className="publication-text">
					<p className="item-subhead">{publication.header}</p>
					<p className="item-body">{publication.body}</p>
				</div>
			</a>
		</AnimationOnScroll>
	}

	render() {
		const publications = [
			{thumb: pubThumb1, header:"THE ULTIMATE GUIDE TO NFT GAS OPTIMIZATION", body: 'The #1 gas optimization resource. Click or just google "NFT Gas Optimization"', href:"https://medium.com/@WallStFam/the-ultimate-guide-to-nft-gas-optimization-7e9289e2d88f"},
			{thumb: pubThumb2, header:"MODELING NFT PRICES WITH SMOOTHED ISOTONIC REGRESSION", body: 'A peek under the hood of BeyondRarity2.0\'s Pricing Analysis Engine', href:"https://medium.com/the-brr/modeling-nft-prices-with-smoothed-isotonic-regression-b4a4393a9301"},
			{thumb: pubThumb3, header:"PROJECT UNIQUENESS RATING (PUR)", body: 'A new way to assess variability of NFTs relative to each other within a collection', href:"https://medium.com/the-brr/viberaters-new-project-uniqueness-rating-pur-dda6be68bb1b"},
			{thumb: pubThumb4, header:"A HODLRS GUIDE TO TRUE NFT RARITY", body: 'The best rarity tool doesn\'t depend on primitive statistics to determine value. It does however, take into account what you value most', href:"https://medium.com/the-brr/a-hodlrs-guide-to-true-nft-rarity-c91f395b5291"}
		]
		return (
		<div id="publications" className="publications-container overflow-left-margin overflow-right-margin">
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">PUBLICATIONS</h1>
					<div className="briefing-text">
					</div>
				</div>
			</AnimationOnScroll>
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-showcase blue-gradient">
					<div className="publication-list">
						{publications.map(p=>this.renderPublication(p))}
						<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={300}>
							<Button variant='outlineBlueAnimated' onClick={()=>{window.open('https://medium.com/the-brr','_blank')}}>
								MORE AT OUR MEDIUM.COM PAGE <img style={{width:'30px', filter:'invert(1)', marginLeft:'10%', animation: 'pulse-blue-svg 4s infinite'}} src={mediumSVG} alt="medium-icon"/>
							</Button>
						</AnimationOnScroll>
					</div>
				</div>
			</AnimationOnScroll>
		</div>
		);
	}

	openModal(){
		this.setState({isMenuOpen:true})
	}
}
